module.exports = __webpack_public_path__ + "static/media/logo.15409a0b.svg";